module.exports = __webpack_public_path__ + "img/八公桥镇.1d8d88cc.png";